module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu02-55cb3d1fc58c21601c6091503068be3e.png";